import { render } from "./Novedades.vue?vue&type=template&id=2f00efc3"
import script from "./Novedades.vue?vue&type=script&lang=js"
export * from "./Novedades.vue?vue&type=script&lang=js"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__